module.exports = __webpack_public_path__ + "img/Cover_FS_25.950b9d75.jpg";